import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";
import VueMoment from "vue-moment";
import VueScrollTo from "vue-scrollto";
import VueCookies from "vue-cookies";
import VueCarousel from "vue-carousel";
import VueSweetalert2 from "vue-sweetalert2";
import Dropdown from "bp-vuejs-dropdown";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VSelect from "vue-select-picker-bootstrap";
import { BootstrapVue} from 'bootstrap-vue';

Vue.config.productionTip = true;
Vue.use(VueScrollTo);
Vue.use(VueTheMask);
Vue.use(VueMoment);
Vue.use(VueCarousel);
Vue.use(VueCookies);
Vue.use(VueSweetalert2);
Vue.use(Dropdown);
Vue.use(VSelect);
Vue.use(BootstrapVue);

Vue.filter("currency", (value) => {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
